import styles from "./styles.module.scss";
import swal from "sweetalert";
import {
  clearLocalTranscriptData,
  getLocalTranscriptData,
} from "../../../../services/LocalStorageManager";
import {
  saveTranscript,
  createReportForTranscript,
  deleteTranscript,
} from "../../../../api/transcriptsApi";
import { useDispatch } from "react-redux";
import { updateDataset } from "../../../../redux/dataset/datasetSlice";
import { useNavigate } from "react-router-dom";
import hasEmptySpeaker from "../../../../services/CheckEmptySpeakers";

export default function ActionButtons({ dataset }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  if (dataset && dataset.transcript_status !== "COMPLETED") {
    return (
      <div className={styles.actionButtons}>
        <button
          className={styles.delete}
          onClick={(e) => {
            e.preventDefault();
            swal({
              title: "ATTENTION! This will remove the transcript completely!",
              text: "This action will delete the transcript and all its data from our system. This action can't be reverted. Are you sure you want to delete the transcript?",
              icon: "warning",
              buttons: ["Cancel", "Delete"],
              dangerMode: true,
            }).then(async (willDelete) => {
              if (willDelete) {
                try {
                  const isSuccess = await deleteTranscript(dataset.file_id);
                  if (isSuccess) {
                    swal(
                      "Transcript deleted",
                      "Your transcript has been deleted successfully!",
                      "success"
                    ).then(() => {
                      navigate("/transcripts");
                    });
                  }
                } catch (error) {
                  console.error("Error deleting the transcript:", error);
                  swal(
                    "Something went wrong",
                    "Error deleting the transcript. Please try again.",
                    "error"
                  );
                }
              }
            });
          }}
        >
          Delete
        </button>
        <button
          className={styles.reset}
          onClick={(e) => {
            e.preventDefault();
            swal({
              title: "Are you sure?",
              text: "Are you sure you want to reset? It will revert the changes to the last Save",
              icon: "warning",
              buttons: ["Cancel", "Reset"],
              dangerMode: true,
            }).then((willReset) => {
              if (willReset) {
                clearLocalTranscriptData(dataset.file_id);
                window.location.reload();
              }
            });
          }}
        >
          Reset
        </button>
        <button
          className={styles.save}
          onClick={async (e) => {
            e.preventDefault();
            try {
              const isSuccess = await saveTranscript(dataset.file_id, dataset);
              if (isSuccess) {
                swal(
                  "Transcript updated",
                  "Your transcript has been updated successfully!",
                  "success"
                );
              }
            } catch (error) {
              console.error("Error updating the transcript:", error);
              swal(
                "Something went wrong",
                "Error updating transcript. Please try again.",
                "error"
              );
            }
          }}
        >
          Update
        </button>
        <button
          className={styles.complete}
          onClick={async (e) => {
            e.preventDefault();
            dispatch(updateDataset({ transcript_status: "COMPLETED" }));
            const emptySpeakers = hasEmptySpeaker(dataset.transcript.segments);
            if (emptySpeakers) {
              swal(
                "Your transcript is not done yet",
                "There are segments with no speakers attached. Please go through the transcript again. The segment without a speaker will be marked in red.",
                "error"
              );
            } else {
              swal({
                title: "You are about to complete the transcript",
                text: "Are you sure you want to complete the transcript? You will not be able to make any changes after this.",
                icon: "info",
                buttons: ["Cancel", "Complete"],
                className: "swal-custom",
              }).then(async (willComplete) => {
                if (willComplete) {
                  try {
                    const data = await getLocalTranscriptData(dataset.file_id);
                    const isSuccess = await saveTranscript(
                      dataset.file_id,
                      data
                    );
                    if (isSuccess) {
                      swal(
                        "Transcript completed",
                        "Your transcript has been completed successfully!",
                        "success"
                      );
                      setTimeout(async () => {
                        await createReportForTranscript(dataset);
                        clearLocalTranscriptData(dataset.file_id);
                      }, 100);
                    }
                  } catch (error) {
                    console.error("Error saving transcript:", error);
                    swal(
                      "Something went wrong",
                      "Error completing the transcript. Please try again.",
                      "error"
                    );
                    dispatch(updateDataset({ transcript_status: "GENERATED" }));
                  }
                } else {
                  dispatch(updateDataset({ transcript_status: "GENERATED" }));
                }
              });
            }
          }}
        >
          Complete
        </button>
      </div>
    );
  } else {
    return (
      <div className={styles.actionButtons}>
        <button
          className={styles.unlock}
          onClick={(e) => {
            e.preventDefault();
            dispatch(updateDataset({ transcript_status: "GENERATED" }));
          }}
        >
          Unlock
        </button>
        <button className={styles.complete} disabled>
          Completed
        </button>
      </div>
    );
  }
}
